import type { Resource } from '../../';
export const content_video_fullscreen: Resource = {"default":"Enter Fullscreen"};
